export const headerSection = {
  benefits: 'Avantages',
  partners: 'Les partenaires',
  setups: 'Configurations',
};
export const description =
  "Le soleil est notre principale source d'énergie et de vie sur Terre. Les combustibles fossiles étaient autrefois créés à partir de son énergie, mais aujourd'hui, nous les consommons si rapidement que nous allons bientôt les épuiser. L'exploitation de l'énergie solaire est le premier pas vers une prise de conscience environnementale. Nous sommes heureux de pouvoir vous accompagner sur ce chemin.";